import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import RouteErrorBoundary from 'components/RouteErrorBoundary';
import GuestGuard from './GuestGuard';

// ==============================|| AUTH PAGES ||============================== //

const LoginPage = Loadable(
  lazy(() => import('pages/auth/Login'))
);

const RegisterPage = Loadable(
  lazy(() => import('pages/auth/Register'))
);

const ForgotPasswordPage = Loadable(
  lazy(() => import('pages/auth/ForgotPassword'))
);

const ResetPasswordPage = Loadable(
  lazy(() => import('pages/auth/ResetPassword'))
);

const ClinicAdminSetupPage = Loadable(
  lazy(() => import('pages/auth/ClinicAdminSetup'))
);



// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  ),
  errorElement: <RouteErrorBoundary />,

  children: [

    // Default Route
    {
      index: true,
      element: <LoginPage />
    },

    // Login
    {
      path: 'login',
      element: <LoginPage />
    },

    // Register
    {
      path: 'register',
      element: <RegisterPage />
    },

    // Forgot Password
    {
      path: 'forgot-password',
      element: <ForgotPasswordPage />
    },

    {
      path: 'reset-password',
      element: <ResetPasswordPage />
    },

    {
      path: 'setup/:token',
      element: <ClinicAdminSetupPage />
    },

    {
      path: 'setup',
      element: <ClinicAdminSetupPage />
    },

    {
      path: 's/:token',
      element: <ClinicAdminSetupPage />
    },

    {
      path: 'clinic-admin/setup',
      element: <ClinicAdminSetupPage />
    },

    {
      path: 'clinic-admin/register',
      element: <ClinicAdminSetupPage />
    },

    {
      path: 'clinic/setup',
      element: <ClinicAdminSetupPage />
    }
  ]
};

export default LoginRoutes;
